"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("../constants");
var _createAction = require("../helpers/createAction.js");
var ClinicalPearls = /*#__PURE__*/function () {
  function ClinicalPearls(api) {
    var _this = this;
    _classCallCheck(this, ClinicalPearls);
    this.pearlFetch = (0, _createAction.createApiRequestAction)({
      getKey: function getKey() {
        return "clinical_pearls";
      },
      request: function request(getState, questionBankId, userId) {
        var _getState = getState(),
          session = _getState.session,
          users = _getState.users;
        var currentUserId = userId || session.get('current_user_id');
        var currentQuestionBankId = questionBankId || session.get('selected_question_bank_id', 0);
        return _this.api.get("users/".concat(currentUserId, "/question_banks/").concat(currentQuestionBankId, "/clinical_pearls"));
      },
      loadingConstant: _constants.CLINICAL_PEARLS_FETCHING,
      loadedConstant: _constants.CLINICAL_PEARLS_FETCHED,
      errorConstant: _constants.CLINICAL_PEARLS_FETCH_ERROR
    });
    this.markPearl = (0, _createAction.createApiRequestAction)({
      getKey: function getKey(userIdArg, pearlIdArg) {
        return "users/".concat(userIdArg, "/clinical_pearls/").concat(pearlIdArg, "/mark");
      },
      request: function request(getState, userIdArg, pearlIdArg) {
        return _this.api.put("users/".concat(userIdArg, "/clinical_pearls/").concat(pearlIdArg, "/mark"));
      },
      loadingConstant: _constants.PEARL_MARKED,
      loadedConstant: _constants.PEARL_MARKED,
      errorConstant: _constants.PEARL_MARK_ERROR
    });
    this.unmarkPearl = (0, _createAction.createApiRequestAction)({
      getKey: function getKey(userIdArg, pearlIdArg) {
        return "users/".concat(userIdArg, "/clinical_pearls/").concat(pearlIdArg, "/unmark");
      },
      request: function request(getState, userIdArg, pearlIdArg) {
        return _this.api.put("users/".concat(userIdArg, "/clinical_pearls/").concat(pearlIdArg, "/unmark"));
      },
      loadingConstant: _constants.PEARL_UNMARKED,
      loadedConstant: _constants.PEARL_UNMARKED,
      errorConstant: _constants.PEARL_UNMARK_ERROR
    });
    this.api = api;
  }
  _createClass(ClinicalPearls, [{
    key: "clinicalPearlFetchKey",
    value: function clinicalPearlFetchKey() {
      return 'clinical_pearls';
    }
  }]);
  return ClinicalPearls;
}();
var _default = exports.default = ClinicalPearls;